import { useCodatAuth } from "@codat/client-cookie-manager";
import { makePublicApi } from "api/publicApi";
import { PublicService, makePublicService } from "api/services/publicService";
import React, { PropsWithChildren, createContext, useContext } from "react";

export const PublicServiceContext = createContext<PublicService | undefined>(
  undefined
);

export const usePublicService = (): PublicService => {
  const service = useContext(PublicServiceContext);

  if (service === undefined) {
    throw new Error("PublicService must be initialised before use");
  }
  return service;
};

export const PublicApiProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const auth = useCodatAuth();
  const publicApi = makePublicApi(auth);
  const publicService = makePublicService(publicApi);

  return (
    <PublicServiceContext.Provider value={publicService}>
      {children}
    </PublicServiceContext.Provider>
  );
};
